import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { combineLatest, map, Observable, switchMap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export const PageTitleResolver: ResolveFn<string> = (
  route,
  state,
  translate: TranslateService = inject(TranslateService)): Observable<string> => {

  const translateId = route.data['translateId'];
  let appTitle$ = translate.get(`appName`);

  if (!translateId) {
    return appTitle$;
  }

  let sectionTitle$ = translate.get(`pageTitles.${translateId}`);

  let fullTitle$ = combineLatest([appTitle$, sectionTitle$]).pipe(
    map(([appTitle, sectionTitle]) => {
      console.log('Resolving page title:', `${sectionTitle} | ${appTitle}`);
      return `${sectionTitle} | ${appTitle}`;
    }));

  return fullTitle$
};

